import React, { useEffect, useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Col, Row } from 'react-bootstrap'
import { ElementHTML, formatArgentinePhone } from '@helpers/helper.rendering'
import { RealEstateDataFooterData } from 'types'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import toast from 'react-hot-toast'
import ReCAPTCHA from 'react-google-recaptcha'
import { useGetSummarySiteQuery } from '@apis/mediacore/core'

const Footer15 = (props: RealEstateDataFooterData) => {
  const {
    image_gatsby,
    image_bottom_gatsby,
    image_bottom,
    title,
    titles,
    paragraph,
    backgroundHexa,
    titleElement,
    titleHexa,
    global_data,
    paragraphHexa,
    socialMediaFooter,
    button,
    height,
    opacityValue,
    titlesElement,
  } = props

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const topImage = image_gatsby ? getImage((image_gatsby as any)?.url || image_gatsby) : null

  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const realEstateName = global_data.name

  const captcha = global_data.pageConfig.keys.captcha

  const [disabled, setDisabled] = useState(true)

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const sendForm = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    const tags = ['Sitio Web', 'Newsletter', realEstateName]
    sendContactFormMediacore({
      data: { ...datos, tags, token: token },
      type: 'newsletter',
      site: global_data.id,
    })
    ;(document.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    return toast.success('Te suscribiste a nuestro newsletter correctamente.')
  }

  const handleInputChange = (e: { target: { name: string; value: string } }) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    })
  }

  const [datos, setDatos] = useState({
    email: '',
  })

  const siteId = global_data.id

  const { data: allSiteData } = useGetSummarySiteQuery(
    process.env.GATSBY_IS_SITE_COMPILER == 'true' ? siteId : process.env.GATSBY_TENANTID,
  )
  const INVESTOR_CONFIGURATION = allSiteData?.custom_login?.find(
    (config: { module: string }) => config.module === 'INVESTOR',
  )
  const OWNER_CONFIGURATION = allSiteData?.custom_login?.find(
    (config: { module: string }) => config.module === 'OWNER',
  )

  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const cssVars = {
    '--titlesElements-mobile': titlesElement?.mobile || 'initial',
    '--titlesElements-desktop': titlesElement?.desktop || 'initial',
    '--opacityValue': opacityValue ? String(Number(opacityValue) / 100) : '0',
  } as React.CSSProperties

  return (
    isMounted && (
      <footer
        className="footer-15"
        style={{
          background: backgroundHexa || 'transparent',
          color: titleHexa || '#fff',
          ...cssVars,
        }}
      >
        {(title || paragraph) && (
          <div
            className="footer-15__hero d-flex align-items-center"
            style={{
              height: screen.width < 768 ? height?.mobile || '360px' : height?.desktop || '360px',
            }}
          >
            {topImage && (
              <GatsbyImage
                image={topImage}
                alt={title || 'Newsletter image'}
                style={{ height: '100%', position: 'absolute', top: 0, left: 0, zIndex: 0 }}
                className="footer-15__hero-image"
              />
            )}

            <div
              className="container"
              style={{ zIndex: 1 }}
            >
              <div className="footer-15__hero-overlay d-lg-flex align-items-center">
                <Col lg={6}>
                  <ElementHTML
                    children={title}
                    style={{ color: titleHexa || '#fff' }}
                    elementType={titleElement || 'h2'}
                    className="mb-4"
                  />
                  <ElementHTML
                    children={paragraph}
                    style={{ color: paragraphHexa }}
                    elementType={'p'}
                  />
                </Col>
                <Col
                  lg={6}
                  className="d-flex justify-content-lg-end"
                >
                  <form
                    onSubmit={sendForm}
                    id="formNewsletter"
                    className="w-100"
                  >
                    <div className="d-flex mb-lg-3 justify-content-lg-end">
                      <input
                        type="email"
                        onChange={handleInputChange}
                        name="email"
                        required
                        placeholder="Ingresá tu mail"
                        className={`mr-2 `}
                      />
                      <button
                        disabled={disabled}
                        type="submit"
                        className={'submit '}
                        style={{
                          background: button?.backgroundColor || '#fff',
                          color: button?.valueColor || '#000',
                        }}
                        aria-label="Boton enviar formulario"
                      >
                        ENVIAR
                      </button>
                    </div>
                    {captcha ? (
                      <ReCAPTCHA
                        sitekey={captcha}
                        onChange={(value) => {
                          setDisabled(false)
                          onChange(value)
                        }}
                      />
                    ) : (
                      ''
                    )}
                  </form>
                </Col>
              </div>
            </div>
          </div>
        )}

        <div
          className="footer-15__bottom"
          style={{ background: backgroundHexa || '#222' }}
        >
          <div className="container">
            <Row className="footer-15__columns justify-content-center text-start text-lg-start text-center">
              <Col
                xs={12}
                md={4}
                className="mb-4 mb-md-0"
              >
                <h5
                  className={'mb-4'}
                  style={{ color: titleHexa || '#fff' }}
                >
                  {titles?.global}
                </h5>
                {global_data.contact_data.phoneLine?.at(0) && (
                  <p className="text-white">
                    Teléfono:{' '}
                    {formatArgentinePhone(global_data.contact_data.phoneLine?.at(0) ?? '')}
                  </p>
                )}
                {global_data.contact_data.phoneMobile?.at(0) && (
                  <p style={{ color: titleHexa || '#fff' }}>
                    Whatsapp:{' '}
                    <a
                      style={{ color: titleHexa || '#fff' }}
                      href={`https://wa.me/${global_data.contact_data.phoneMobile?.at(0) ?? ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {formatArgentinePhone(global_data.contact_data.phoneMobile?.at(0) ?? '')}
                    </a>{' '}
                  </p>
                )}
                {global_data.contact_data.email && (
                  <p style={{ color: titleHexa || '#fff' }}>
                    <a
                      style={{ textTransform: 'uppercase', color: titleHexa || '#fff' }}
                      href={`mailto:${global_data.contact_data.email ?? ''}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {global_data.contact_data.email ?? ''}
                    </a>
                  </p>
                )}
              </Col>

              <Col
                xs={12}
                md={3}
                className="mb-4 mb-md-0 text"
              >
                <h5
                  className={'mb-4'}
                  style={{ color: titleHexa || '#fff' }}
                >
                  {titles?.branch_office}
                </h5>
                <p style={{ color: titleHexa || '#fff' }}>
                  {global_data.branches.at(0)?.address ?? ''}{' '}
                  {global_data.branches.at(0)?.zip_code ?? ''}
                </p>
                {global_data.branches.at(0)?.city && (
                  <p style={{ color: titleHexa || '#fff' }}>
                    {global_data.branches.at(0)?.city + ', ' + global_data.branches.at(0)?.country}
                  </p>
                )}
              </Col>

              {INVESTOR_CONFIGURATION?.module ||
                (OWNER_CONFIGURATION?.module && (
                  <Col
                    xs={12}
                    md={5}
                    className="mb-4 mb-md-0 text-start d-none d-md-block"
                  >
                    <h5
                      className={'mb-4'}
                      style={{ color: titleHexa || '#fff' }}
                    >
                      {titles?.modules}
                    </h5>
                    <div className="footer-15__buttons">
                      {INVESTOR_CONFIGURATION?.module && (
                        <div className="d-block">
                          <a
                            className="btn btn-investor mb-2 d-block d-lg-inline-block"
                            target={'_blank'}
                            href={INVESTOR_CONFIGURATION.url_login}
                          >
                            {INVESTOR_CONFIGURATION.text_cta || 'INVERSORES'}
                            {<i className={'icon-investment' + iconsStyle}></i>}
                          </a>
                        </div>
                      )}
                      {OWNER_CONFIGURATION?.module && (
                        <div className="d-block">
                          <a
                            className="btn btn-investor mb-2 d-block d-lg-inline-block"
                            target={'_blank'}
                            href={OWNER_CONFIGURATION.url_login}
                          >
                            {OWNER_CONFIGURATION.text_cta || 'PROPIETARIOS'}
                            {<i className={'icon-investor-access' + iconsStyle}></i>}
                          </a>
                        </div>
                      )}
                    </div>
                  </Col>
                ))}
            </Row>

            <hr
              style={{ background: titleHexa || '#fff' }}
              className="footer-15__divider"
            />

            <Row className="justify-content-center align-items-center footer-15__brand">
              <Col
                xs={12}
                className="text-center"
              >
                {image_bottom_gatsby ? (
                  <GatsbyImage
                    image={getImage(image_bottom_gatsby as any)!}
                    alt="Logo"
                    className="footer-15__logo"
                  />
                ) : image_bottom ? (
                  <img
                    src={image_bottom}
                    alt="Logo"
                    className="footer-15__logo"
                  />
                ) : null}

                <div className="footer-15__socials mt-3 mb-lg-5 mb-4">
                  {socialMediaFooter?.map((social, index) => (
                    <a
                      key={index ? social.link : '#'}
                      href={social.link || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={social.image}
                        alt={social.link}
                      />
                    </a>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </footer>
    )
  )
}

export default Footer15
